import { Box, Stack, TextField, Typography } from "@mui/material";
import { useAuth } from "src/context/AuthContext";
import StepHeader from "./StepHeader";
import SectionHeader from "./SectionHeader";
import AttachmentsSection from "./AttachmentsSection";
import { useT } from "src/i18n";

export default function StepDetails({
    draft,
    onChange,
    isAuthenticated,
    person,
    attachments,
    pumppuRequestId,
    onRefetchAttachments,
    onPreClaimDraft,
    onUploadingChange,
}) {
    const { token } = useAuth();
    const t = useT();
    const update = (key) => (e) => onChange({ [key]: e.target.value });

    return (
        <Stack spacing={2}>
            <StepHeader>{t("wizard.stepDetails.title")}</StepHeader>
            <TextField
                label={t("wizard.stepDetails.driveLabel")}
                fullWidth
                multiline
                minRows={2}
                value={draft.ajoOhjeet}
                onChange={update("ajoOhjeet")}
                helperText={t("wizard.stepDetails.driveHelper")}
            />
            <TextField
                label={t("wizard.stepDetails.otherLabel")}
                fullWidth
                multiline
                minRows={3}
                value={draft.kuvaus}
                onChange={update("kuvaus")}
                helperText={t("wizard.stepDetails.otherHelper")}
            />

            {isAuthenticated && person ? (
                <AttachmentsSection
                    pumppuRequestId={pumppuRequestId}
                    attachments={attachments ?? []}
                    onRefetch={onRefetchAttachments}
                    token={token}
                    ownerAsiakasId={person.ownerAsiakasId}
                    entryByPersonId={person.personId}
                    onPreClaim={onPreClaimDraft}
                    onUploadingChange={onUploadingChange}
                />
            ) : (
                <Box>
                    <SectionHeader title={t("wizard.attachmentsSection.title")} />
                    <Typography variant="body2" sx={{ fontSize: 13, lineHeight: 1.55, color: "text.secondary" }}>
                        {t("wizard.stepDetails.attachmentsAuthNote")}
                    </Typography>
                </Box>
            )}
        </Stack>
    );
}
